"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = buildUrlFromIds;
var URL_LIMIT = 2000;
function buildUrlFromIds(path, ids) {
  var initialPath = "".concat(path, "?ids=");
  var remainingCharacters = URL_LIMIT - initialPath.length;
  var idLength = ids[0].length + 1; // + 1 for commas
  var idsToTake = Math.floor(remainingCharacters / idLength);
  return "".concat(initialPath).concat(ids.splice(0, idsToTake).join(','));
}